const ToggleSwitch = ({
  name,
  label,
  labelClasses,
  onChange,
  value,
  disabled,
  variant = "purple",
}: {
  name: string;
  label: string;
  onChange: () => void;
  value: boolean;
  labelClasses?: string;
  disabled: boolean;
  variant?: "purple" | "red";
}) => {
  const checkedBgClass = variant === "red" ? "checked:bg-red-600" : "checked:bg-purple-light";
  const borderColor = variant === "red" ? "border-red-600" : "border-[#635F5F]";
  
  return (
    <label className="flex cursor-pointer items-center">
      <div
        className={
          "mr-2 inline-block pl-[0.15rem] text-lg font-bold text-[#635F5F] hover:cursor-pointer" +
          (labelClasses ?? "")
        }
      >
        {label}
      </div>
      <div className={`border-1 relative flex items-center justify-center rounded-[15px] border-solid ${borderColor} p-[2px]`}>
        <input
          className={`checked:after:bg-primary checked:focus:border-primary checked:focus:bg-primary dark:checked:bg-primary dark:checked:after:bg-primary mr-2 h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] ${checkedBgClass} checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] disabled:opacity-50 dark:bg-neutral-600 dark:after:bg-neutral-400 dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]`}
          type="checkbox"
          role="switch"
          checked={value}
          onChange={onChange}
          name={name}
          disabled={disabled}
        />
      </div>
    </label>
  );
};

export default ToggleSwitch;
